// NOTICE: KAPTION-INTEGRATION
// team-location.HIDDEN.1 — "if the feature is not enabled, it should not even
// appear". Every team location entry point in the dashboard asks these helpers.
//
// Both checks FAIL CLOSED, on purpose unlike the generic
// `accounts/isFeaturePermittedonAccount` getter (which fails open when the
// permissions payload is missing): location is personal data, so a missing or
// stale account payload hides it instead of showing it.
//
//   account enabled  `kaption_team_location_enabled === true` on the account
//                    record (team_location_tracking or team_location_view has a
//                    scope other than off). Gates the settings entry, the
//                    webhook event and the settings route.
//   can view map     account enabled AND the user's effective permission map is
//                    present AND `team_location_view` is true in it. Gates the
//                    map sidebar entry and the map route.

export const TEAM_LOCATION_VIEW_KEY = 'team_location_view';
export const TEAM_LOCATION_WEBHOOK_EVENT = 'agent_location_updated';

export const isTeamLocationEnabledForAccount = account =>
  account?.kaption_team_location_enabled === true;

export const canViewTeamLocationMap = account =>
  isTeamLocationEnabledForAccount(account) &&
  account?.kaption_feature_permissions?.[TEAM_LOCATION_VIEW_KEY] === true;

// The webhook form's event list, without the location event while disabled.
export const filterTeamLocationWebhookEvents = (events, account) =>
  isTeamLocationEnabledForAccount(account)
    ? events
    : events.filter(event => event !== TEAM_LOCATION_WEBHOOK_EVENT);

// team-location.HIDDEN.4 — route guard for the map and settings routes. A
// direct URL while disabled goes to the account's dashboard (no "not enabled"
// page). On a cold load the account record may not be in the store yet, so it
// is fetched once before deciding; if that fails the route stays closed.
export const buildTeamLocationRouteGuard =
  (isAllowed, getStore) => async to => {
    const store = getStore();
    const accountId = Number(to.params.accountId);
    let account = store.getters['accounts/getAccount'](accountId);
    if (!account?.id) {
      try {
        await store.dispatch('accounts/get');
      } catch {
        // fall through: closed
      }
      account = store.getters['accounts/getAccount'](accountId);
    }
    if (isAllowed(account)) return true;
    return { name: 'home', params: { accountId: to.params.accountId } };
  };
